export interface INavigationStateModel {
  history: string[];
}

export const NAVIGATION_INITIAL_STATE: INavigationStateModel = {
  history: [],
};
